import React from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { createdUpdatedInfo } from '../../../utils';
import ShiftTimePicker from './ShiftTimePicker';
import { Employee, HandleShiftSave } from './ShiftScheduler';
import { Shift } from '../Shifts/types';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    handleShiftSave: (shift: Shift) => Promise<void>;
    deleteShift: (id: number) => Promise<void>;
    selectedTeamId: number | undefined;
    selectedDay: string;
    initialStartTime?: string;
    initialEndTime?: string;
    existingShifts: Array<Shift>;
    selectedEmployee: Employee;
    existingShiftId: number | undefined;
}

export default function ModalShiftTimePicker ({
    modal,
    setModal,
    handleShiftSave,
    deleteShift,
    selectedDay,
    selectedTeamId,
    initialStartTime,
    initialEndTime,
    existingShifts,
    selectedEmployee,
    existingShiftId
}: Props) {

    const toggle = () => setModal(!modal);
    
    if (!selectedEmployee) return null;

    return (
        <CustomModal isOpen={modal} toggle={toggle} size={'lg'}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Schedule Shift for {selectedEmployee.s_first_name} {selectedEmployee.s_last_name}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <ShiftTimePicker 
                    handleShiftSave={handleShiftSave} 
                    deleteShift={deleteShift}
                    selectedTeamId={selectedTeamId}
                    selectedDay={selectedDay}
                    initialStartTime={initialStartTime}
                    initialEndTime={initialEndTime}
                    existingShifts={existingShifts}
                    selectedEmployee={selectedEmployee}
                    existingShiftId={existingShiftId}
                />
            </ModalBody>
            {/* <ExpandedFooter>
                <FooterContentContainer>
                    <Label>
                        {createdUpdatedInfo({})}
                    </Label>
                    <FooterButtonsContainer>
                        <ActionIcon type={'save'} onClick={() => {}} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter> */}
        </CustomModal>
    );
}

const CustomModal = styled(Modal)`
    max-width: 75%;
`;

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;